<script>
	import Config from '../Config.js';
	import Helper from '../Models/Helper.js';
	import Gallery from '../States/Gallery.js';
	import Render from '../States/Render.js';

	const canvas = document.createElement('canvas');
	canvas.width = Config.render.width;
	canvas.height = Config.render.height;

	const context = canvas.getContext('2d');
	let cache = {};

	function load(url) {
		const draw = image => {
			context.drawImage(image, 0, 0, canvas.width, canvas.height);
		};

		return new Promise((resolve, reject) => {
			if (Helper.undefined(cache[url])) {
				const image = new Image();
				image.crossOrigin = 'anonymous';
				image.onload = event => {
					draw(image);
					resolve();
				};

				image.onerror = event => {
					console.error('Render image load error.');
					resolve();
				}

				image.src = url;
				cache[url] = image;
			}

			else {
				draw(cache[url]);
				resolve();
			}
		});
	}

	async function render() {
		try {
			context.clearRect(0, 0, canvas.width, canvas.height);

			let loaded = false;
			for (const url of $Render)
				if (url) {
					await load(url);
					loaded = true;
				}

			const data = canvas.toDataURL('image/jpeg', .9);
			Gallery.render(data);
			if (loaded) $Gallery.loaded = true;
		}

		catch (error) {
			console.error(error);
		}
	}

	Render.subscribe(render);
</script>